"use strict";
/**
 * Created by rouven on 06.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PAGINATION_COUNT_FORMAT_FULL = exports.PAGINATION_COUNT_FORMAT_SHORT = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
// @ts-ignore
var react_pager_1 = __importDefault(require("react-pager"));
var index_1 = require("../../actions/index");
var react_router_dom_1 = require("react-router-dom");
var PAGINATION_COUNT_FORMAT_SHORT = function (_a) {
    var totalCount = _a.totalCount;
    return (totalCount + ' Zeile(n)');
};
exports.PAGINATION_COUNT_FORMAT_SHORT = PAGINATION_COUNT_FORMAT_SHORT;
var PAGINATION_COUNT_FORMAT_FULL = function (_a) {
    var currentPage = _a.currentPage, pageCount = _a.pageCount, perPage = _a.perPage, totalCount = _a.totalCount;
    var valueFrom = (currentPage - 1) * perPage + 1;
    var valueTo = currentPage * perPage;
    return (valueFrom + ' bis ' + (valueTo < totalCount ? valueTo : totalCount) + ' von ' + totalCount + ' Einträgen');
};
exports.PAGINATION_COUNT_FORMAT_FULL = PAGINATION_COUNT_FORMAT_FULL;
var renderPageSizeOptions = function (pageSizes, perPage) {
    if (pageSizes.indexOf(perPage) === -1) {
        pageSizes.push(perPage);
        pageSizes.sort(function (a, b) { return a - b; });
    }
    // @ts-ignore
    return pageSizes.map(function (value, i) { return react_1["default"].createElement("option", __assign({}, value, { key: 'psso_' + i }), value); });
};
var Pagination = function (_a) {
    var grid = _a.grid, currentPage = _a.currentPage, _b = _a.pageCount, pageCount = _b === void 0 ? 0 : _b, perPage = _a.perPage, totalCount = _a.totalCount, handlePageChanged = _a.handlePageChanged, handlePageSizeChanged = _a.handlePageSizeChanged, pageSizes = _a.pageSizes, _c = _a.paginationCountFormat, paginationCountFormat = _c === void 0 ? exports.PAGINATION_COUNT_FORMAT_SHORT : _c;
    return react_1["default"].createElement("div", { className: "row grid-before-table" },
        react_1["default"].createElement("div", { className: "col-md-3" },
            react_1["default"].createElement("div", { className: "grid-filter grid-filter--entries" }, paginationCountFormat({ currentPage: currentPage, pageCount: pageCount, perPage: perPage, totalCount: totalCount }))),
        react_1["default"].createElement("div", { className: "col-md-6" },
            react_1["default"].createElement("div", { className: "text-center" },
                react_1["default"].createElement(react_pager_1["default"], { total: pageCount, current: currentPage - 1, titles: {
                        first: 'Erste Seite',
                        prev: '\u00AB',
                        prevSet: '...',
                        nextSet: '...',
                        next: '\u00BB',
                        last: 'Letzte Seite'
                    }, visiblePages: 5, onPageChanged: function (nextPage) { return handlePageChanged(nextPage, grid); } }))),
        react_1["default"].createElement("div", { className: "col-md-3 text-right" },
            react_1["default"].createElement("div", { className: "grid-filter grid-filter--entries-per-page" },
                react_1["default"].createElement("div", { className: "form-inline" },
                    react_1["default"].createElement("label", { htmlFor: "pagesizeSelect" }, "Eintr\u00E4ge pro Seite:"),
                    react_1["default"].createElement("select", { value: perPage, name: "pagesizeSelect", className: "input-sm form-control", onChange: function (evt) { return handlePageSizeChanged(evt, grid); } }, renderPageSizeOptions(pageSizes, perPage))))));
};
// @ts-ignore
var mapDispatchToProps = function (dispatch, _a) {
    var replace = _a.replace, location = _a.location;
    return ({
        // @ts-ignore
        handlePageSizeChanged: function (evt, grid) { return dispatch((0, index_1.changePageSize)(evt, grid)(replace, location)); },
        // @ts-ignore
        handlePageChanged: function (nextPage, grid) { return dispatch((0, index_1.changePage)(nextPage, grid)(replace, location)); }
    });
};
var PaginationContainer = (0, react_redux_1.connect)(null, mapDispatchToProps)(Pagination);
var PaginationWrapper = function (_a) {
    var grid = _a.grid, pageSizes = _a.pageSizes, rest = __rest(_a, ["grid", "pageSizes"]);
    var replace = (0, react_router_dom_1.useHistory)().replace;
    var location = (0, react_router_dom_1.useLocation)();
    return react_1["default"].createElement(PaginationContainer, __assign({ replace: replace, location: location, grid: grid, pageSizes: pageSizes }, rest));
};
exports["default"] = PaginationWrapper;
